import React from 'react';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { openModal } from '@/Store/Slices/ModalSlice';

const BannersActionBtns = ({image, mob_image}) => {
  const dispatch = useDispatch();

  const showImage = (src) => {
    dispatch(openModal({
      modalType: 'show-image',
      modalProps: {
        src,
      }
    }))
  }

  return (
    <div className='flex'>
      <button onClick={() => showImage(image)} className='mr-3' data-tip="Show image for computers">
        <FontAwesomeIcon
          color={'blue'}
          size={'lg'}
          icon={solid('desktop')}/>
      </button>
      <button onClick={() => showImage(mob_image)} data-tip="Show image for mobiles">
        <FontAwesomeIcon
          color={'green'}
          size={'lg'}
          icon={solid('mobile')}/>
      </button>
    </div>
  );
};

export default BannersActionBtns;
